// extracted by mini-css-extract-plugin
export default {"chartWrapper":"DataChart_chartWrapper__Er4wx"};